if (!customElements.get('peakride-booking-cta')) {
  customElements.define(
    'peakride-booking-cta',
    class PeakrideBookingCta extends HTMLElement {
      constructor() {
        super();

        this.variants = new Set();
        this.currentVariantId = null;
        this.unsubscribeVariantChange = null;
      }

      connectedCallback() {
        this.bookingLink = this.querySelector(
          '[data-peakride-booking-link]'
        );

        this.variantsJson = this.querySelector(
          '[data-peakride-variants]'
        );

        this.loadVariants();
        this.updateVariant(this.dataset.initialVariantId);
        this.initializeVariantSubscription();

        this.bookingLink?.addEventListener(
          'click',
          this.markBookingNavigation
        );
      }

      disconnectedCallback() {
        this.unsubscribeVariantChange?.();

        this.bookingLink?.removeEventListener(
          'click',
          this.markBookingNavigation
        );
      }

      loadVariants() {
        if (!this.variantsJson) return;

        try {
          const variants = JSON.parse(
            this.variantsJson.textContent
          );

          variants.forEach((variant) => {
            this.variants.add(String(variant.id));
          });
        } catch (error) {
          console.error(
            'peakride: Variantendaten konnten nicht geladen werden.',
            error
          );
        }
      }

      initializeVariantSubscription() {
        if (
          typeof subscribe !== 'function' ||
          typeof PUB_SUB_EVENTS === 'undefined' ||
          !PUB_SUB_EVENTS.variantChange
        ) {
          return;
        }

        this.unsubscribeVariantChange = subscribe(
          PUB_SUB_EVENTS.variantChange,
          ({ data }) => {
            this.updateVariant(data.variant?.id);
          }
        );
      }

      updateVariant(variantId) {
        if (!variantId || !this.bookingLink) return;

        const normalizedId = String(variantId);

        if (!this.variants.has(normalizedId)) return;

        this.currentVariantId = normalizedId;

        this.bookingLink.href =
          `/pages/buchung?variant=${encodeURIComponent(normalizedId)}`;
      }

      markBookingNavigation = () => {
        try {
          sessionStorage.setItem(
            'peakrideBookingNavigation',
            JSON.stringify({
              productPath: window.location.pathname,
              variantId: this.currentVariantId,
              createdAt: Date.now()
            })
          );
        } catch (error) {
          console.error(
            'peakride: Buchungsnavigation konnte nicht gespeichert werden.',
            error
          );
        }
      };
    }
  );
}

if (!customElements.get('peakride-booking-bar')) {
  customElements.define(
    'peakride-booking-bar',
    class PeakrideBookingBar extends HTMLElement {
      constructor() {
        super();

        this.variants = new Map();
        this.currentVariantId = null;
        this.unsubscribeVariantChange = null;
      }

      connectedCallback() {
        this.priceElement = this.querySelector(
          '[data-peakride-booking-price]'
        );

        this.bookingLink = this.querySelector(
          '[data-peakride-sticky-booking-link]'
        );

        this.variantsJson = this.querySelector(
          '[data-peakride-variants]'
        );

        this.loadVariants();
        this.updateVariant(this.dataset.initialVariantId);
        this.initializeVariantSubscription();

        this.bookingLink?.addEventListener(
          'click',
          this.markBookingNavigation
        );

        document.body.classList.add(
          'peakride-booking-active'
        );
      }

      disconnectedCallback() {
        this.unsubscribeVariantChange?.();

        this.bookingLink?.removeEventListener(
          'click',
          this.markBookingNavigation
        );

        if (!document.querySelector('peakride-booking-bar')) {
          document.body.classList.remove(
            'peakride-booking-active'
          );
        }
      }

      loadVariants() {
        if (!this.variantsJson) return;

        try {
          const variants = JSON.parse(
            this.variantsJson.textContent
          );

          variants.forEach((variant) => {
            this.variants.set(
              String(variant.id),
              variant
            );
          });
        } catch (error) {
          console.error(
            'peakride: Variantendaten konnten nicht geladen werden.',
            error
          );
        }
      }

      initializeVariantSubscription() {
        if (
          typeof subscribe !== 'function' ||
          typeof PUB_SUB_EVENTS === 'undefined' ||
          !PUB_SUB_EVENTS.variantChange
        ) {
          return;
        }

        this.unsubscribeVariantChange = subscribe(
          PUB_SUB_EVENTS.variantChange,
          ({ data }) => {
            this.updateVariant(data.variant?.id);
          }
        );
      }

      updateVariant(variantId) {
        if (!variantId) return;

        const normalizedId = String(variantId);
        const variant = this.variants.get(normalizedId);

        if (!variant) return;

        this.currentVariantId = normalizedId;

        if (this.priceElement) {
          this.priceElement.textContent = variant.price;
        }

        if (this.bookingLink) {
          this.bookingLink.href =
            `/pages/buchung?variant=${encodeURIComponent(normalizedId)}`;
        }
      }

      markBookingNavigation = () => {
        try {
          sessionStorage.setItem(
            'peakrideBookingNavigation',
            JSON.stringify({
              productPath: window.location.pathname,
              variantId: this.currentVariantId,
              createdAt: Date.now()
            })
          );
        } catch (error) {
          console.error(
            'peakride: Buchungsnavigation konnte nicht gespeichert werden.',
            error
          );
        }
      };
    }
  );
}